import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Output, EventEmitter } from '@angular/core';
import { ToastController } from 'ionic-angular';

export class PollMultipleAbstract {

  @Output()
  public sendAnswer: EventEmitter<any> = new EventEmitter();

  public questionId: string;

  public form: FormGroup;

  public objFrom: Object;

  constructor(
    public fb: FormBuilder,
    public toastCtrl: ToastController
  ) { }

  public setQuestionId(questionId){
    this.questionId = questionId;
  }
  public buildForm(objForm) {
    this.form = new FormGroup(objForm);
  }

  public patchForm(obj){
    this.form.patchValue(obj);
  }

  public getObjectForm(options: any[]) {
    const objForm = {};
    for (const option of options) {
      // option.title =  option.title.replace(/[^\w\d]/gi, '').trim();
      objForm[`${option['id']}`] = new FormControl(false);
    }
    this.objFrom = objForm;
    this.buildForm(objForm);
  }


  public onFormSubmited({ value, valid}: { value: any, valid: boolean }) {
    if (valid) {
      this.sendAnswer.emit({id: this.questionId, value:value});
    }
  }

  public showMessage(message: string) {
    this.toastCtrl.create({
      message: message,
      duration: 3000
    }).present();
  }

}



// WEBPACK FOOTER //
// ./src/abstracts/poll-multiple.abstract.ts